import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { lang } from '../../../common/baseData'

const FilterSection = (filter) => {
	const handleCheckboxChange = (newID,select,newName,sectionCodes,isParent,parentId) => {
		const url = new URL(window.location.href);

		let updatedFilterSelectedValue;

		if (isParent) {
			// Обработка родительского раздела
			const isCategoryIncludes = select.includes(newID);

			if (isCategoryIncludes) {
				// Снимаем выбор с родителя и всех его подразделов
				const childrenIds = getAllChildrenIds(newID, filter.filter);
				updatedFilterSelectedValue = select.filter(
					id => id !== newID && !childrenIds.includes(id)
				);
			} else {
				// Выбираем только родителя
				updatedFilterSelectedValue = [...select, newID];
			}
		} else {
			// Обработка дочернего раздела
			const isCategoryIncludes = select.includes(newID);

			if (isCategoryIncludes) {
				// Снимаем выбор с дочернего элемента
				updatedFilterSelectedValue = select.filter(id => id !== newID);
			} else {
				// Выбираем дочерний элемент и снимаем выбор с родителя
				updatedFilterSelectedValue = [...select, newID];
				if (parentId && select.includes(parentId)) {
					updatedFilterSelectedValue = updatedFilterSelectedValue.filter(id => id !== parentId);
				}
			}
		}

		const updatedFilterSelectedValueCodes = {};

		Object.keys(sectionCodes).forEach(key => {
			if (updatedFilterSelectedValue.includes(parseInt(key))) {
				updatedFilterSelectedValueCodes[key] = sectionCodes[key];
			}
		});

		const resultString = Object.entries(updatedFilterSelectedValueCodes)
			.map(([key, value]) => `${value}`)
			.join('-');

		// Удаляем все после /news/
		url.pathname = url.pathname.replace(/\/news\/.*/, '/news/');

		if(resultString){
			url.pathname = `${url.pathname}${resultString}/`;
		}

		// Удаляем значение по маске "/page=*"
		url.pathname = url.pathname.replace(/\/page=[^\/]*/, '');

		const newUrl = url.toString();

		// Добавляем текущий URL в историю
		window.history.pushState({ url: newUrl }, null, newUrl);

		filter.setLangLink(url.pathname);
		filter.onCategoryChange(newID, newName);
	};

	// Получить все ID дочерних элементов для родителя
	const getAllChildrenIds = (parentId, filterData) => {
		const childrenIds = [];

		if (filterData.VALUES) {
			Object.values(filterData.VALUES).forEach(value => {
				if (value.SECTION_ID === parentId && value.CHILDREN) {
					value.CHILDREN.forEach(child => {
						childrenIds.push(child.SECTION_ID);
					});
				}
			});
		}

		return childrenIds;
	};

	const [isActive, setIsActive] = useState(false);

	const handleFilterItemClick = () => {
		const filterBoxTitle = document.querySelector('.filter-box__title');

		if (filterBoxTitle) {
			const parent = filterBoxTitle.parentNode;

			if (parent.classList.contains('active')) {
				parent.classList.remove('active');

				const filterBoxContainer = parent.querySelector('.filter-box__container');
				if (filterBoxContainer) {
					filterBoxContainer.style.display = 'none';
				}
			} else {
				parent.classList.add('active');

				const filterBoxContainer = parent.querySelector('.filter-box__container');
				if (filterBoxContainer) {
					filterBoxContainer.style.display = 'block'; // или 'flex' или другие значения в зависимости от вашего дизайна
				}
			}

			setIsActive(!isActive); // если необходимо отслеживать состояние класса active в React state
		}
	};

	const renderFilterItems = () => {
		const values = filter.filter.VALUES;

		// Проверка на пустоту или undefined
		if (!values || Object.keys(values).length === 0) {
			return null; // или пустой массив, в зависимости от вашего использования
		}

		return Object.entries(values).map(([id, value]) => (
			<li key={value.SECTION_ID} className={`filter-item ${value.CHILDREN && value.CHILDREN.length > 0 ? 'filter-item-parent' : ''}`}>
				<div className="checkbox">
					<label>
						<span className="input-checkbox">
							<input
								type="checkbox"
								className={value.CHILDREN && value.CHILDREN.length > 0 ? 'parent-checkbox' : ''}
								value={value.SECTION_ID}
								name={`${filter.filter.CODE}[]`}
								onChange={() => handleCheckboxChange(
									value.SECTION_ID,
									filter.select,
									value.SECTION_NAME,
									filter.sectionCodes,
									true,
									null
								)}
								checked={filter.select.includes(value.SECTION_ID)}
							/>
							<span className="checkbox-text">
								<span>{value.SECTION_NAME}</span>
								<span className="count"> ({value.ELEMENT_COUNT})</span>
							</span>
						</span>
					</label>
				</div>

				{value.CHILDREN && value.CHILDREN.length > 0 && (
					<ul className="filter-items-list filter-items-list-children">
						{value.CHILDREN.map(child => (
							<li key={child.SECTION_ID} className="filter-item filter-item-child">
								<div className="checkbox">
									<label>
										<span className="input-checkbox">
											<input
												type="checkbox"
												className="child-checkbox"
												value={child.SECTION_ID}
												name={`${filter.filter.CODE}[]`}
												data-parent={value.SECTION_ID}
												onChange={() => handleCheckboxChange(
													child.SECTION_ID,
													filter.select,
													child.SECTION_NAME,
													filter.sectionCodes,
													false,
													value.SECTION_ID // parentId
												)}
												checked={filter.select.includes(child.SECTION_ID)}
											/>
											<span className="checkbox-text">
												<span>{child.SECTION_NAME}</span>
												<span className="count"> ({child.ELEMENT_COUNT})</span>
											</span>
										</span>
									</label>
								</div>
							</li>
						))}
					</ul>
				)}
			</li>
		));
	};

	return (
		<div className="filter-box active">
			<div className={`filter-box__title ${isActive ? 'active' : ''}`} onClick={handleFilterItemClick}>{filter.filter.NAME}</div>
			<div className="filter-box__container">
				<ul className="filter-items-list">{renderFilterItems()}</ul>
			</div>
		</div>
	);
};

const BlogFilter = (filters) => {
	if (!filters) {
		return null; // Можно также вернуть заглушку или другой контент по вашему усмотрению
	}
	const renderFilterSections = () => {
		return Object.values(filters).map((filter) => {
			if (!filter.hasOwnProperty('VALUES')) {
				return null; // пропускаем это значение
			}
			return <FilterSection key={filter.ID} filter={filter} select={filters.filterSectionSelect} sectionCodes={filters.filterSectionCodes} onCategoryChange={filters.onCategoryChange} setLangLink={filters.setLangLink}/>;
		});
	};

	return (
		<div className="filter-section">
			<span className="close-filter" onClick={(event) => filters.handleMobileFilter(event)}></span>
			<div className="filter-title"><span>{`${lang === 'ru' ? 'Фильтры' : 'Фільтри'}`}</span></div>
			<div className="filter__container">
				{renderFilterSections()}
			</div>
		</div>
	);
};

export default BlogFilter;